export default __webpack_public_path__ + "static/media/loader.a14a65ca.svg";